import React, { useContext, Suspense } from "react";
import DynamicLayout from "../components/DynamicLayout";
import { PlatformContext } from "../context/PlatformContext";
import { MobileComponents, DesktopComponents, LoadingComponent } from '../helpers/platformUtils';
import NoIndexHelmet from '../components/NoIndexHelmet';

const SettingsPage = () => {
  const { platform, loading } = useContext(PlatformContext);
  
  if (loading) {
    return (
      <DynamicLayout>
        <NoIndexHelmet title="Settings | Saturnalia" />
        <LoadingComponent />
      </DynamicLayout>
    );
  }

  const isMobile = platform === 'mobileApp' || platform === 'mobileWeb';
  const MobileComponent = MobileComponents.Settings;
  const DesktopComponent = DesktopComponents.Settings;

  return (
    <DynamicLayout>
      <NoIndexHelmet title="Settings | Saturnalia" />
      <Suspense fallback={<LoadingComponent />}>
        {isMobile ? (
          <MobileComponent />
        ) : (
          <DesktopComponent />
        )}
      </Suspense>
    </DynamicLayout>
  );
};

export default SettingsPage;

